import { useRedirection } from '@/_shared';

export function RedirectExternal({ to }: { to: string }) {
  useRedirection(to);

  return null;
}
